<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'RoomMain',
}
</script>

<style></style>
